module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/ko-eb7a5c9361dba85f66728c406dda2cde.jpg";